import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getMeta = () => api.get("/meta").then((r) => r.data);
export const listGins = (params = {}) => api.get("/gins", { params }).then((r) => r.data);
export const getGin = (id) => api.get(`/gins/${id}`).then((r) => r.data);
export const getRelated = (id) => api.get(`/gins/${id}/related`).then((r) => r.data);
export const filterGins = (body) => api.post("/filter", body).then((r) => r.data);
export const runMatchmaker = (body) => api.post("/matchmaker", body).then((r) => r.data);
export const getSurpriseOptions = () => api.get("/surprise/options").then((r) => r.data);
export const surprise = (option) => api.post("/surprise", { option }).then((r) => r.data);
export const compareGins = (gin_ids) => api.post("/compare", { gin_ids }).then((r) => r.data);
